function getClientId(): string | null {
  const gaCookie = document.cookie.split(";").find(function getCookies(el) {
    const [key] = el.split("=");
    return key?.trim() === "_ga";
  });
  if (!gaCookie) {
    return null;
  }
  const [, value] = gaCookie.split("=");
  return value?.substring(6) ?? null;
}

export default getClientId;
